<!-- Visitors -->
<div>
  <!-- Toolbar: search + filters -->
  <div class="flex flex-wrap items-end gap-3 px-4 py-3 border-b border-gray-200 bg-gray-50">

    <!-- Loading spinner -->
    <div *ngIf="isLoading" class="flex items-center gap-2 text-sm text-gray-500">
      <mat-progress-spinner diameter="16" color="primary" mode="indeterminate"></mat-progress-spinner>
      Loading…
    </div>

    <!-- Search input -->
    <div class="relative">
      <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2.5">
        <svg class="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
        </svg>
      </div>
      <input type="text"
        (keyup)="applyFilter($event)"
        [(ngModel)]="searchValue"
        placeholder="Search…"
        class="block w-48 rounded-md border border-gray-300 bg-white py-1.5 pl-8 pr-8 text-sm
               text-gray-900 placeholder:text-gray-400
               focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500" />
      <button *ngIf="searchValue" (click)="searchValue = ''; applyFilter($event)"
        class="absolute inset-y-0 right-0 flex items-center pr-2 text-gray-400 hover:text-gray-600">
        <svg class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Dynamic filter selects -->
    <div *ngFor="let empfilter of empFilters" class="flex flex-col gap-0.5">
      <label class="text-xs font-medium text-gray-500">{{ empfilter.name }}</label>
      <select [(ngModel)]="empfilter.defaultValue" (change)="applyEmpFilterNative($event, empfilter)"
        class="rounded-md border border-gray-300 bg-white py-1.5 pl-3 pr-7 text-sm text-gray-900
               focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 cursor-pointer">
        <option *ngFor="let op of empfilter.options" [value]="op">{{ op }}</option>
      </select>
    </div>

  </div>

  <div class="example-container" dragScroll>
    <table
      mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z0"
      matSort
      matSortActive="t_visitorid"
      matSortDisableClear
      matSortDirection="desc"
      matTableExporter
      #exporter="matTableExporter">
      <!----------------------------------------------------------------- -->

      <!-- ID Column -->
      <ng-container matColumnDef="t_visitorid" sticky>
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
        <td mat-cell *matCellDef="let row">{{ row.t_visitorid }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">Total</td>
      </ng-container>

      <!-- zusatz1 Column -->
      <ng-container matColumnDef="zusatz1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">Status</th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="row.zusatz1 == 'LAST_YEAR'"
            class="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600">
            Last Year
          </span>
          <span *ngIf="row.zusatz1 == 'PENDING_APPROVAL'"
            class="inline-flex items-center rounded-full bg-yellow-50 px-2 py-0.5 text-xs font-medium text-yellow-700 ring-1 ring-inset ring-yellow-600/20">
            Register
          </span>
          <span *ngIf="row.zusatz1 == 'APPROVED_OK' && row.firststart_done == 0"
            class="inline-flex items-center rounded-full bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/20">
            Approved
          </span>
          <span *ngIf="row.zusatz1 == 'APPROVED_OK' && row.firststart_done == 1"
            class="inline-flex items-center rounded-full bg-green-50 px-2 py-0.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
            Active
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- Profilbild Column -->
      <ng-container matColumnDef="profile_image">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-50">&nbsp;</th>
        <td mat-cell *matCellDef="let row">
          <phuture-iavatar src_image="{{ imageStorage }}{{ row.profile_image }}"></phuture-iavatar>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- Country Column -->
      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-80">PAYS</th>
        <td mat-cell *matCellDef="let row">
          {{ getCountryName(row.country) }}
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">
          {{ calculateTotal('country') }}
        </td>
      </ng-container>

      <!----------------------------------------------------------------- -->

      <!-- Company Column -->
      <ng-container matColumnDef="company" sticky>
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-150">SOCIETE</th>
        <td mat-cell *matCellDef="let row">{{ row.company }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- decharge_resp_civile Column -->
      <ng-container matColumnDef="decharge_resp_civile">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>CIVILE DEVIS</th>
        <td mat-cell *matCellDef="let row">
          <div *ngIf="!row.decharge_resp_civile || row.decharge_resp_civile == 0">-</div>
          <div *ngIf="row.decharge_resp_civile == -1 || row.decharge_resp_civile == 1">1</div>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">
          {{ calculateTotal('decharge_resp_civile') }}
        </td>
      </ng-container>

      <!-- estimate Column -->
      <ng-container matColumnDef="estimate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>DEVIS</th>
        <td mat-cell *matCellDef="let row">{{ row.estimate }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">
          {{ calculateTotal('estimate') }}
        </td>
      </ng-container>

      <!----------------------------------------------------------------- -->

      <!-- title Column -->
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">TITLE</th>
        <td mat-cell *matCellDef="let row">{{ row.title }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- lastname Column -->
      <ng-container matColumnDef="lastname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-80">NOM</th>
        <td mat-cell *matCellDef="let row">{{ row.lastname }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- firstname Column -->
      <ng-container matColumnDef="firstname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-80">PRENOM</th>
        <td mat-cell *matCellDef="let row">{{ row.firstname }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- position Column -->
      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">FONCTION</th>
        <td mat-cell *matCellDef="let row">{{ row.position }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- adress Column -->
      <ng-container matColumnDef="adress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-150">ADRESSE</th>
        <td mat-cell *matCellDef="let row">{{ row.adress }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- areacode Column -->
      <ng-container matColumnDef="areacode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-80">CP</th>
        <td mat-cell *matCellDef="let row">{{ row.areacode }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- city Column -->
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">VILLE</th>
        <td mat-cell *matCellDef="let row">{{ row.city }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- companyphone Column -->
      <ng-container matColumnDef="companyphone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-150">TEL</th>
        <td mat-cell *matCellDef="let row">{{ row.companyphone }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- emailincharge Column -->
      <ng-container matColumnDef="emailincharge">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-80">EMAIL In Charge</th>
        <td mat-cell *matCellDef="let row">{{ row.emailincharge }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- companymail Column -->
      <ng-container matColumnDef="companymail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-80">Company EMAIL</th>
        <td mat-cell *matCellDef="let row">{{ row.companymail }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- icphone Column -->
      <ng-container matColumnDef="icphone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-80">Phone In Charge</th>
        <td mat-cell *matCellDef="let row">{{ row.icphone }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- website Column -->
      <ng-container matColumnDef="website">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-80">WEB</th>
        <td mat-cell *matCellDef="let row">{{ row.website }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!----------------------------------------------------------------- -->

      <!-- chkcity1 Column -->
      <ng-container matColumnDef="chkcity1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Day 1</th>
        <td mat-cell *matCellDef="let row">
          <div *ngIf="!row.chkcity1 || row.chkcity1 == 0">-</div>
          <div *ngIf="row.chkcity1 == -1 || row.chkcity1 == 1">{{ row.chkcity1 }}</div>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">{{ calculateTotal('chkcity1') }}</td>
      </ng-container>

      <!-- chkcity2 Column -->
      <ng-container matColumnDef="chkcity2">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Day 2</th>
        <td mat-cell *matCellDef="let row">
          <div *ngIf="!row.chkcity2 || row.chkcity2 == 0">-</div>
          <div *ngIf="row.chkcity2 == -1 || row.chkcity2 == 1">{{ row.chkcity2 }}</div>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">{{ calculateTotal('chkcity2') }}</td>
      </ng-container>

      <!-- garage_day1 Column -->
      <ng-container matColumnDef="garage_day1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Garage Day 1</th>
        <td mat-cell *matCellDef="let row">
          <div *ngIf="!row.garage_day1 || row.garage_day1 == 0">-</div>
          <div *ngIf="row.garage_day1 == -1 || row.garage_day1 == 1">{{ row.garage_day1 }}</div>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">{{ calculateTotal('garage_day1') }}</td>
      </ng-container>

      <!-- garage_day2 Column -->
      <ng-container matColumnDef="garage_day2">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Garage Day 2</th>
        <td mat-cell *matCellDef="let row">
          <div *ngIf="!row.garage_day2 || row.garage_day2 == 0">-</div>
          <div *ngIf="row.garage_day2 == -1 || row.garage_day2 == 1">{{ row.garage_day2 }}</div>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">{{ calculateTotal('garage_day2') }}</td>
      </ng-container>

      <!-- lunch_day1 Column -->
      <ng-container matColumnDef="lunch_day1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>DEJ Day 1</th>
        <td mat-cell *matCellDef="let row">
          <div *ngIf="!row.lunch_day1 || row.lunch_day1 == 0">-</div>
          <div *ngIf="row.lunch_day1 == -1 || row.lunch_day1 == 1">{{ row.lunch_day1 }}</div>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">{{ calculateTotal('lunch_day1') }}</td>
      </ng-container>

      <!-- lunch_day2 Column -->
      <ng-container matColumnDef="lunch_day2">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>DEJ Day 2</th>
        <td mat-cell *matCellDef="let row">
          <div *ngIf="!row.lunch_day2 || row.lunch_day2 == 0">-</div>
          <div *ngIf="row.lunch_day2 == -1 || row.lunch_day2 == 1">{{ row.lunch_day2 }}</div>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">{{ calculateTotal('lunch_day2') }}</td>
      </ng-container>

      <!-- attendance_event Column -->
      <ng-container matColumnDef="attendance_event">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>SOIREE</th>
        <td mat-cell *matCellDef="let row">
          <div *ngIf="!row.attendance_event || row.attendance_event == 0">-</div>
          <div *ngIf="row.attendance_event == -1 || row.attendance_event == 1">{{ row.attendance_event }}</div>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">{{ calculateTotal('attendance_event') }}</td>
      </ng-container>

      <!-- hotel_stay_night Column -->
      <ng-container matColumnDef="hotel_stay_night">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>NUITEE</th>
        <td mat-cell *matCellDef="let row">
          <div *ngIf="!row.hotel_stay_night || row.hotel_stay_night == 0">-</div>
          <div *ngIf="row.hotel_stay_night == -1 || row.hotel_stay_night == 1">{{ row.hotel_stay_night }}</div>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">{{ calculateTotal('hotel_stay_night') }}</td>
      </ng-container>

      <!-- transfer_arrival Column -->
      <ng-container matColumnDef="transfer_arrival">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>TRANSFERT ALLER</th>
        <td mat-cell *matCellDef="let row">
          <div *ngIf="!row.transfer_arrival || row.transfer_arrival == 0">-</div>
          <div *ngIf="row.transfer_arrival == -1 || row.transfer_arrival == 1">{{ row.transfer_arrival }}</div>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">{{ calculateTotal('transfer_arrival') }}</td>
      </ng-container>

      <!-- transfer_return Column -->
      <ng-container matColumnDef="transfer_return">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>TRANSFERT RETOUR</th>
        <td mat-cell *matCellDef="let row">
          <div *ngIf="!row.transfer_return || row.transfer_return == 0">-</div>
          <div *ngIf="row.transfer_return == -1 || row.transfer_return == 1">{{ row.transfer_return }}</div>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">{{ calculateTotal('transfer_return') }}</td>
      </ng-container>

      <!-- data1 Column -->
      <ng-container matColumnDef="data1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ALLER</th>
        <td mat-cell *matCellDef="let row">{{ row.data1 }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- flight_booked Column -->
      <ng-container matColumnDef="flight_booked">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>FLIGHT BOOKED</th>
        <td mat-cell *matCellDef="let row">
          <div *ngIf="!row.flight_booked || row.flight_booked == 0">-</div>
          <div *ngIf="row.flight_booked == -1 || row.flight_booked == 1">{{ row.flight_booked }}</div>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">{{ calculateTotal('flight_booked') }}</td>
      </ng-container>

      <!-- data2 Column -->
      <ng-container matColumnDef="data2">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>TYPE</th>
        <td mat-cell *matCellDef="let row">{{ row.data2 }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- firststart Bewegungsdaten / logistics Columns -->
      <ng-container [matColumnDef]="column" *ngFor="let column of bewegungsdatenColumns; let i = index">
        <th mat-header-cell *matHeaderCellDef>{{ bewegungsdatenHeaders[i] }}</th>
        <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- special_wishes Column -->
      <ng-container matColumnDef="special_wishes">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Remarque</th>
        <td mat-cell *matCellDef="let row">{{ row.special_wishes }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- additional Columns -->
      <ng-container [matColumnDef]="column" *ngFor="let column of additionalColumns; let i = index">
        <th mat-header-cell *matHeaderCellDef>{{ beautyNamesColumns[i] }}</th>
        <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <!-- actions button bar Column -->

      <ng-container matColumnDef="actions" stickyEnd>
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let row">
          <button
            type="button"
            (click)="showPageDetail(row)"
            class="inline-flex items-center gap-1 rounded bg-blue-700 px-2.5 py-1
                   text-xs font-medium text-white hover:bg-blue-900
                   transition-colors duration-150">
            <svg class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
            </svg>
            Edit
          </button>
        </td>
        <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let emprow; columns: displayedColumns" (click)="showPageDetail(emprow)"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
    </table>
  </div>
  <mat-paginator
    #paginator
    [length]="totalItems"
    [pageSize]="initPageSize"
    [pageSizeOptions]="pageSizes"
    showFirstLastButtons></mat-paginator>
</div>
<div class="flex items-center gap-2 px-4 py-3 border-t border-gray-100">
  <button type="button" (click)="showAdditionalColumns()"
    class="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-700
           hover:bg-gray-50 transition-colors">
    Add extended fields
  </button>
  <button type="button" (click)="exporter.exportTable('xlsx')"
    class="rounded-md bg-blue-900 px-3 py-1.5 text-xs font-medium text-white
           hover:bg-blue-800 transition-colors">
    Export Excel
  </button>
</div>
